import React from "react";
import ProfessionalExperience from "../components/Experience/ProfessionalExperience";
import VolunteerExperience from "../components/Experience/VolunteerExperience";
import SEO from "../components/common/SEO";

const ExperiencePage = () => {
  const experienceStructuredData = {
    "@context": "https://schema.org",
    "@type": "ProfilePage",
    "name": "Professional Experience & Career - Mihir Shah",
    "description": "Professional work experience, career history, and volunteer contributions of Mihir Shah in cybersecurity, OWASP project leadership, and security engineering.",
    "url": "https://mihirshah.tech/experience",
    "mainEntity": {
      "@type": "Person",
      "name": "Mihir Shah",
      hasOccupation: [
        {
          "@type": "Occupation",
          "name": "Security Engineer",
          "description": "Expert in cloud security, application security, and DevSecOps",
        },
        {
          "@type": "Occupation", 
          "name": "OWASP Project Leader",
          "description": "Leading the OWASP VXDF (Validated Exploitable Data Flow) project",
        },
        {
          "@type": "Occupation",
          "name": "Security Consultant",
          "description": "Providing cybersecurity consulting and expertise",
        },
      ],
      "memberOf": [
        {
          "@type": "Organization",
          "name": "OWASP Foundation",
          "description": "Open Web Application Security Project",
        },
      ],
      "worksFor": {
        "@type": "Organization",
        "name": "Security Industry",
      },
    },
  };

  return (
    <>
      <SEO
        title="Professional Experience & Career History - Mihir Shah"
        description="Explore Mihir Shah's professional experience in cybersecurity, security engineering roles, OWASP project leadership, volunteer contributions, and career progression in the security industry."
        keywords="Mihir Shah experience, cybersecurity career, security engineer experience, OWASP project leader, professional history, volunteer work, security consulting experience"
        url="https://mihirshah.tech/experience"
        type="website"
        section="Experience"
        tags={["Experience", "Career", "Professional History", "Volunteer Work"]}
        structuredData={experienceStructuredData}
      />
      <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-gray-900 py-20">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-vxdf-primary to-vxdf-accent bg-clip-text text-transparent">
              Professional Experience
            </h1>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Career journey in cybersecurity, security engineering, OWASP project leadership, and volunteer contributions to the security community
            </p>
          </div>
          
          <ProfessionalExperience />
          <VolunteerExperience />
        </div>
      </div>
    </>
  );
};

export default ExperiencePage;
